import React, { FC } from "react";
import { IFormItem, ITreeData } from "../Types";
import { Form, TreeSelect } from "antd";

export const __FormTreeSelect: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <TreeSelect
                disabled={props.disable}
                allowClear={props.allowClear}
                treeData={props.treeDs}
                onChange={props.onChange}
                onFocus={props.onFocus}
                loadData={props.loadData}
                multiple={props.multiple}
                treeCheckable={props.treeCheckable}
                onSelect={(value: string, option) => props.onTreeSelectChange?.(value, option as ITreeData)}

            />
        </Form.Item>
    )
}